<input
  (input)="onInputChange($event)"
  [max]="maxValue"
  [ngModel]="currentDayPosition"
  class="form-range"
  min="0"
  step="1"
  type="range"
/>
